import { proxy } from 'valtio'

export const windowSizeState = proxy({
  currentWidth: window.innerWidth,
  currentHeight: window.innerHeight,

  get mobileMode() {
    return this.currentWidth <= 912
  },
  get phoneMode() {
    return this.currentWidth <= 430
  },
  get infoPCMode() {
    return this.currentWidth <= 1400
  },
  get isMobileRotate() {
    return this.currentWidth < 768
  },
})

let timeoutID = setTimeout(() => {}, 1000)

const handleResize = () => {
  windowSizeState.currentWidth = window.innerWidth
  windowSizeState.currentHeight = window.innerHeight
}

const debouncedHandleResize = () => {
  clearTimeout(timeoutID)
  timeoutID = setTimeout(handleResize, 250)
}

window.addEventListener('resize', debouncedHandleResize)
